import { FC } from 'react';
import { Progress } from "@chakra-ui/react";

type Props = {
  percent: number;
}

export const ProgressBar: FC<Props> = ({percent}) => (
  <Progress value={percent} className="progress-bar" />
);
